import { z } from 'zod';

import { ComponentValidator, ComponentPayloadValidator } from '../Component';

import { synchronize, synchronizePowerFlowDirection } from '../helpers';

import { AbstractPort, Port } from '../fields/AbstractPort';
import { Resistance } from '../fields/Resistance';

import { ComponentDefinition } from '../../types/ComponentDefinition';

const port = AbstractPort.extend({
    AC: Port.AC.default({}),
    DC: Port.DC.default({}),
    powerFlowDirection: Port.powerFlowDirection.literals.bidirectional,
}).default({});

const electrical = z
    .object({
        ports: z.tuple([port, port]).default([undefined, undefined]),
        resistance: Resistance.validator,
    })
    .default({});

const PrechargeBase = z.object({
    type: z.literal('precharge').default('precharge'),
    electrical: synchronize(synchronizePowerFlowDirection(electrical), {
        'ports.0': ['ports.1'],
    }),
});

export const PrechargeValidator = ComponentValidator.merge(PrechargeBase);
export const PrechargePayloadValidator = ComponentPayloadValidator.merge(PrechargeBase);

export const PrechargeDefinition: ComponentDefinition = {
    type: 'precharge',
    name: 'Precharge',
    plural: 'Precharges',
    indicator: 'PRE',
    hasDynamicNumberOfPorts: false,
    interoperabilityDataModel: false,
    liveData: {
        enabled: true,
        showGraphs: false,
    },
    ports: {
        min: 2,
        max: 2,
        powerFlowDirections: ['bidirectional'],
        displayAsSinglePort: true,
    },
    validators: {
        component: PrechargeValidator,
        payload: PrechargePayloadValidator,
    },
};

export type Precharge = z.infer<typeof PrechargeValidator>;
export type PrechargePayload = z.infer<typeof PrechargePayloadValidator>;
